import React from 'react';
import { ArrowRight } from 'lucide-react';

export const CTA = () => {
  return (
    <section className="relative overflow-hidden">
      <div className="section-divider"></div>

      {/* Subtle glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[400px] bg-[#00ffd5]/[0.03] rounded-full blur-[150px]"></div>

      <div className="container mx-auto px-6 py-32 relative z-10">
        <div className="max-w-4xl mx-auto">
          {/* Terminal-style frame */}
          <div className="bg-[#0d0d12] border border-white/[0.06] rounded-sm overflow-hidden">
            {/* Top bar */}
            <div className="flex items-center gap-2 px-6 py-3 border-b border-white/[0.04] bg-white/[0.01]">
              <div className="flex gap-1.5">
                <div className="w-2 h-2 rounded-full bg-[#ff3333]/60"></div>
                <div className="w-2 h-2 rounded-full bg-[#ffb800]/60"></div>
                <div className="w-2 h-2 rounded-full bg-[#39ff14]/60"></div>
              </div>
              <span className="font-mono text-[0.6rem] text-white/30 tracking-wider ml-2">SECURE_YOUR_APP.SH</span>
            </div>

            <div className="p-10 md:p-16 text-center">
              <h2 className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-white tracking-tight leading-[1.05] mb-6">
                Your Next Breach
                <br />
                <span className="gradient-accent glow-text">Is Preventable.</span>
              </h2>

              <p className="text-lg text-white/30 max-w-2xl mx-auto mb-10" style={{ fontFamily: 'var(--font-body)' }}>
                30 minutes. One APK upload. You'll see exactly what an attacker sees.
                The only question is whether you want to find out now — or after they do.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                <button
                  className="btn-primary flex items-center gap-3"
                  onClick={() => window.open('https://cal.com/mahima-arora-0f2025/30min?overlayCalendar=true', '_blank')}
                >
                  See It Break Your App
                  <ArrowRight className="w-4 h-4" />
                </button>
              </div>

              <p className="font-mono text-[0.65rem] text-white/30 pt-8 tracking-wider">
                NO CONTRACTS / NO SETUP / RESULTS IN YOUR FIRST SESSION
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
